import type { FeatureAccess, IUser } from 'Model/index.js'
import { hasFeatureAccess, isChatBeta } from 'Model/index.js'
import { Navigate, Outlet } from 'react-router-dom'
import { useUserWasFetched } from '../../../Flux/Selector/Authentication/GetAuthenticatedUser/UserWasFetchedSelector.js'
import React from 'react'

type ProtectedRouteProps = {
  user: IUser | null
  redirectPath?: string
  featureAccessRequired?: FeatureAccess
  /** Gate on a backend-granted role (checked against the `user.roles` array) rather than
   * org/Chargebee feature entitlement. Currently only `CHAT_BETA` for the chat feature. */
  roleRequired?: 'CHAT_BETA'
  children?: React.ReactNode
}

export const ProtectedRoute = ({
  user,
  redirectPath = '/',
  featureAccessRequired,
  roleRequired,
  children
}: ProtectedRouteProps) => {
  const userWasFetched = useUserWasFetched()

  if (!userWasFetched) {
    return <></>
  }

  if (!user) {
    localStorage.setItem('postLoginRedirect', location.pathname + location.search)
    return <Navigate to={redirectPath} replace />
  }

  // does the Route have a access restriction?
  // if so, check if the user has access to the feature
  if (featureAccessRequired && !hasFeatureAccess(user.org, featureAccessRequired)) {
    // if the user does not have access to the feature, redirect to the home page
    console.info("warning: redirecting to home page because user doesn't have access to feature")
    return <Navigate to="/home" replace />
  }

  if (roleRequired === 'CHAT_BETA' && !isChatBeta(user)) {
    console.info("warning: redirecting to home page because user doesn't have the required role")
    return <Navigate to="/home" replace />
  }

  return children ? children : <Outlet />
}
